import { getState } from '../../reduxService';

import * as SelectorMacra1 from '../MACRA_1/selector/conversion';
import * as ProjectMacra1 from '../MACRA_1/store/project/projectSlice';
import * as ResultsMacra1 from '../MACRA_1/store/project/resultsSlice';
import * as TemplateMacra1 from '../MACRA_1/store/template/templateSlice';

import * as SelectorMacra2 from '../MACRA_2/selector/conversion';
import * as ProjectMacra2 from '../MACRA_2/store/project/projectSlice';
import * as ResultsMacra2 from '../MACRA_2/store/project/resultsSlice';
import * as TemplateMacra2 from '../MACRA_2/store/template/templateSlice';

import InputFormMacra2 from '../MACRA_2/components/InputForm/InputForm';
import InputFormMacra1 from '../MACRA_1/components/InputForm/InputForm';

import { EProjectType } from '../enum/project';

import GraphicalResultsMacra1 from '../MACRA_1/components/graphicalResults/GraphicalResults';
import GraphicalResultsMacra2 from '../MACRA_2/components/graphicalResults/GraphicalResults';

export const getActionByProjectType = (projectType?: EProjectType) => {
    let _projectType = projectType ?? getState().projectInfo.data?.type ?? EProjectType.Macra1;
    return _projectType == EProjectType.Macra1
        ? {
              selectTemplate: TemplateMacra1.selectTemplate,
              selectProject: SelectorMacra1.selectProject,
              selectProjectWithoutConversion: SelectorMacra1.selectProjectWithoutConversion,
              selectResults: SelectorMacra1.selectResults,
              setProject: ProjectMacra1.setProject,
              cleanGeometry: ProjectMacra1.cleanGeometry,
              fetchAllTemplate: TemplateMacra1.fetchTemplatesByType,
              fetchTemplateById: ProjectMacra1.fetchTemplateById,
              cleanResults: ResultsMacra1.cleanResults,
              cleanProject: ProjectMacra1.cleanProject,
              inputForm: <InputFormMacra1 />,
              graphicalResults: <GraphicalResultsMacra1 />,
          }
        : {
              selectTemplate: TemplateMacra2.selectTemplate,
              selectProject: SelectorMacra2.selectProject,
              selectProjectWithoutConversion: SelectorMacra2.selectProjectWithoutConversion,
              selectResults: SelectorMacra2.selectResults,
              setProject: ProjectMacra2.setProject,
              cleanGeometry: ProjectMacra2.cleanGeometry,
              fetchAllTemplate: TemplateMacra2.fetchTemplatesByType,
              fetchTemplateById: ProjectMacra2.fetchTemplateById,
              cleanResults: ResultsMacra2.cleanResults,
              cleanProject: ProjectMacra2.cleanProject,
              inputForm: <InputFormMacra2 />,
              graphicalResults: <GraphicalResultsMacra2 />,
          };
};
